/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFormikContext} from 'formik';
import {useState} from 'react';

import FormikLikeInput from '../../../../../components/formikFileds/likeInput';
import FloatingOnlySelectBottomSheet from '../../../../../module/newShop/advertisementRegisteration/floatingOnlySelectBottomSheet';
import {FromikType} from '../../types';
import CommonBottomSheet from '../bottomsheetList/commonBottomSheet';

interface ICommonFieldProps {
  touched: boolean;
  commonBottomSheetData?: Array<{title: string; value: string}>;
  inputName: string;
  bottomSheetName: string;
  label: string;
  secondaryTitle?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  firstInputPlaceHolder?: string;
  inputRequired?: boolean;
  shouldDispatch?: boolean;
  showUnitWhileDisabled?: boolean;
  leftLabel?: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const CommonField = ({
  touched,
  commonBottomSheetData,
  inputName,
  bottomSheetName,
  label,
  secondaryTitle,
  placeholder,
  disabled,
  onChange,
  inputRequired = true,
  firstInputPlaceHolder,
  type,
  shouldDispatch,
  leftLabel,
  showUnitWhileDisabled = false,
  onBlur,
}: ICommonFieldProps) => {
  const {
    values,
    errors,
    touched: formikTouched,
    setFieldValue,
  } = useFormikContext<FromikType>();
  const [openCommonBottomSheet, setOpenCommonBottomSheet] = useState(false);

  return (
    <div className="flex gap-2">
      {commonBottomSheetData && commonBottomSheetData?.length > 0 ? (
        <>
          <div className="w-[200%]">
            <FormikLikeInput
              name={inputName}
              label={label}
              secondaryTitle={secondaryTitle}
              required={inputRequired}
              touched={touched}
              disabled={disabled}
              // placeholder={placeholder}
              placeholder={firstInputPlaceHolder}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onChange
                  ? onChange(e)
                  : setFieldValue(inputName, e.target.value)
              }
              type={type}
              leftLabel={leftLabel}
              onBlur={onBlur}
            />
          </div>
          <FloatingOnlySelectBottomSheet
            Placeholder={placeholder}
            //@ts-ignore
            value={values[bottomSheetName]?.title}
            wrapperClass="border-gray-700 w-[50%]"
            onClick={() => setOpenCommonBottomSheet(true)}
            errors={
              //@ts-ignore
              (touched || formikTouched[bottomSheetName]) &&
              //@ts-ignore
              (errors[bottomSheetName] as any)?.value
            }
          />
          <CommonBottomSheet
            {...{
              openCommonBottomSheet,
              setOpenCommonBottomSheet,
            }}
            name={bottomSheetName}
            shouldDispatch={shouldDispatch}
            bottomSheetData={commonBottomSheetData}
          />
        </>
      ) : (
        <>
          <div className="grow">
            <FormikLikeInput
              name={inputName}
              label={label}
              secondaryTitle={secondaryTitle}
              required={inputRequired}
              touched={touched}
              placeholder={placeholder}
              disabled={disabled}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onChange
                  ? onChange(e)
                  : setFieldValue(inputName, e.target.value)
              }
              type={type}
              leftLabel={leftLabel}
              onBlur={onBlur}
            />
          </div>
          {showUnitWhileDisabled && (
            <div className="flex-none w-1/3">
              <FloatingOnlySelectBottomSheet
                Placeholder={placeholder}
                disabled={disabled}
                //@ts-ignore
                wrapperClass="border-gray-700"
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CommonField;
